module.exports = __webpack_public_path__ + "img/idcard_example_2.dbcc7e62.png";